export const enum SubscriptionsPeriods {
    MONTH = "month",
    DAY = "day",
    MINUTE = "minute",
    WEEK = "week",
}
